export interface UserLocation {
    roleLevel?: number;
    roleName: string;
    roleItemArray?: ILocationItem[];
    employeeArray?: IUserEmployee[];
    roleSelectedItemArray?: ILocationItem[];
    employeeSelectedItemArray?: IUserEmployee[];
    isEmployee?: boolean;
    isHidden?: boolean;
    settings?: IDddlSettings;
    originalSelection?: ILocationItem[];
    originalEmployeeSelection?: IUserEmployee[];
    disableStatus?: string;
    roleNameDisplay?: string;
    staffPositionArray?: IStaffPosition[];
    staffPositionSelectedItemArray?: IStaffPosition[];
    //showStaffPositionDdl?: boolean;
    isStaffPosition?: boolean;
    staffpositionDdlSettings?: IDddlSettings;
}

export interface IDddlSettings {
    singleSelection?: boolean;
    text?: string;
    selectAllText?: string;
    unSelectAllText?: string;
    enableSearchFilter?: boolean;
    badgeShowLimit?: number;
    enableFilterSelectAll?: boolean;
    labelKey?: string;
    primaryKey?: string;
    classes?: string;
    showCheckbox?: boolean;
    disabled?: boolean;
    position?: string;
    lazyLoading?: boolean;
    enableCheckAll?: boolean;
}

export interface IHierachyFilterCache {
    commonHierarchy: UserLocation[];
    positionHierarchy: IPositionHierarchy[];
    version: string;
}

export interface IPositionHierarchy {
    hierarchyGroupId: HirarchyFilterGroup;
    empployees: UserLocation[];
}

export interface IHierachyFilterCacheUrlInfo {
    hierarchyGroupId: HirarchyFilterGroup;
    url: string;
    excludeEmployee: boolean;
    showPosition?: boolean;
    employeeType?: EmployeeType;
    defaultPosition?: string;
    isUseActivityDate?: boolean;
    addExtraPositions?: boolean;
    filterType?: 'P' | 'PR';
}

export interface UserLocationToSave {
    roleLevel?: number;
    roleName: string;
    roleSelectedItemArray?: ILocationItem[] | IUserEmployee[];
    isEmployee?: boolean;
    isStaffPosition: boolean;
    staffPositionSelectedItemArray: IStaffPosition[];
    hierarchyGroupId: HirarchyFilterGroup;
}

export interface ClientHierarchyMain {
    reference: number;
    roleOrder: number;
    roleName?: string;
    description?: string;
    isActive: boolean;
}

export interface ClientHierarchy extends ClientHierarchyMain {
    isActiveOriginal?: boolean;
    roleOrderOriginal?: number;
    roleNameOriginal?: string;
    descriptionOriginal?: string;
    activeShadow?: string;
    isRoleInUse: boolean;
}

export interface HierarchyRoleType {
    roleTypeRef?: string;
    roleType?: string;
}

export interface SavedFilters {
    savedFilterKey?: number;
    filterName?: string;
    filterString?: string;
    isDeleting?: boolean;
}

export interface TileData {
    roleOrder: number;
    hideEditIcon: boolean;
    hideTitleIcon: boolean;
    tileName: string;
    fontIcon: string;
    fontSet: string;
    activeShadow?: string;
    isTopLevel?: boolean;
    tileData?: ClientHierarchy;
    reference: number;
    hideAddButton?: boolean;
    hideCancelButton?: boolean;
    isChanged: boolean;
}

export enum EmployeeType {
    otherEmployee = 'I',
    loanOriginator = 'O',
}

export interface IStaffPosition {
    staffingKey: number;
    position: string;
    positionAbbv: string;
    urlSegment?: string;
}

export enum HirarchyFilterGroup {
    genaralHierarchy = 'genaralHierarchy',
    employeePositionHierarchy = 'employeePositionHierarchy',
}

export interface FilterItems {
    rolename?: string;
    hierarchyidentifier?: string;
}

export interface MainFilterInterface {
    roleLevel?: number;
    roleName: string;
    roleSelectedItemArray?: ILocationItem[];
    employeeSelectedItemArray?: IUserEmployee[];
    isEmployee?: boolean;
}

export interface PageLocationFilters {
    Hierarchy?: FilterItems;
}

export interface ILocationItem {
    hierarchyIdentifier: string;
    hierarchyName: string;
    roleName?: string;
    roleLevel?: number;
    isSubFilter?: boolean;
    employeeIdentifier?: string;
    employee?: string;
    isEmployee?: boolean;
    chipName?: string;
    disableStatus?: string;
}

export interface IUserEmployee {
    employeeIdentifier: string;
    employee: string;
    roleName?: string;
    hierarchyIdentifier?: string;
    hierarchyName?: string;
    roleLevel?: number;
    employeeRole?: string;
}

export interface IEmployeeInfo {
    employeeData: IUserEmployee[];
    employeeType: 'I' | 'O';
}

export interface IHierarchyFilterParameters {
    hFilterJSON?: string;
    employeeType?: EmployeeType;
    isUseActivityDate?: '1' | '0';
    isEmployeeTopLevel?: '1' | '0';
    location?: string;
    subLocation?: string;
    savedFilterKey?: string;
    saveFilterName?: string;
    staffingKey?: string;
    filterType?: string;
}
